import {httpsCallable} from "firebase/functions";
import {functions} from "../Security/firebase-config";
import {FUNCTION_NAMES} from "./functionNames";

export async function beginOversizedVideoProcessing({
  teamId,
  mapId,
  videoId,
}) {
  const callableName =
    FUNCTION_NAMES.beginOversizedVideoProcessing ||
    "beginOversizedVideoProcessingV2";
  const callable = httpsCallable(functions, callableName);
  const response = await callable({
    teamId,
    mapId,
    videoId,
  });
  return response?.data || null;
}

export async function refreshVideoProcessingStatus({
  teamId,
  mapId,
  videoId,
}) {
  const callableName =
    FUNCTION_NAMES.refreshVideoProcessingStatus ||
    "refreshVideoProcessingStatusV2";
  const callable = httpsCallable(functions, callableName);
  const response = await callable({
    teamId,
    mapId,
    videoId,
  });
  return response?.data || null;
}

export function formatProcessingTimeRemaining(totalSeconds) {
  const seconds = Number(totalSeconds);
  if (!Number.isFinite(seconds) || seconds <= 0) return null;

  if (seconds >= 3600) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.ceil((seconds % 3600) / 60);
    return `${hours}h ${minutes}m`;
  }

  if (seconds >= 60) {
    const minutes = Math.floor(seconds / 60);
    const remSeconds = Math.ceil(seconds % 60);
    return `${minutes}m ${remSeconds}s`;
  }

  return `${Math.ceil(seconds)}s`;
}
